module.exports = __webpack_public_path__ + "media/images/lb/458-450380765d433fbd47224b63aae34b15.svg";